import axios from "axios";
import { toast } from "react-toastify";
export const GetAllAccRecievable = (data) => {
  return {
    type: "get_allaccreceivable",
    payload: data,
    loader: false,
  };
};
export function getallaccrecievable() {
  let pgurl = `${
    process.env.REACT_APP_API_URL
  }Reports/AccountsReceivable?projectid=${localStorage.getItem("ProjectId")}`;
  if (localStorage.getItem("ProjectId") === null) {
    pgurl = `${process.env.REACT_APP_API_URL}Reports/AccountsReceivable`;
  }
  return (dispatch) => {
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllAccRecievable(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
